import React from "react"

interface OnboardingStepProps {
  icon: React.ElementType
  children: React.ReactNode
}

const OnboardingStep = ({ icon: Icon, children }: OnboardingStepProps) => (
  <li className="flex border border-primary-light-gray rounded-lg p-4">
    <div className="w-6 h-6 grid place-items-center mr-3 flex-shrink-0">
      <Icon className="w-4 h-4" aria-hidden="true" />
    </div>

    <div className="w-full">{children}</div>
  </li>
)

export default OnboardingStep
